import React from 'react';
import { Grid } from '@mui/material';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import HotelIcon from '@mui/icons-material/Hotel';
import { Section, InfoField } from '../ViewPatientDialog.utils';

export default function LifestyleTab({ patient }) {
  const fiche = patient?.fiche_patient;

  return (
    <Section icon={<RestaurantIcon />} title="Hygiène de vie" subtitle="Alimentation, sommeil, activité physique et loisirs">
      <Grid container spacing={2}>
        <InfoField label="Alimentation" value={fiche?.alimentation} fullWidth multiline />
        <InfoField label="Activités physiques" value={fiche?.activites_physiques} fullWidth multiline icon={<DirectionsRunIcon fontSize="small" />} />
        <InfoField label="Sommeil" value={fiche?.sommeil} icon={<HotelIcon fontSize="small" />} fullWidth multiline />
        <InfoField label="Loisirs" value={fiche?.loisirs} fullWidth multiline />
      </Grid>
    </Section>
  );
}